export { RepeatableBlock, RepeatableBlocks } from "../../../../../shared/frontend/components/RepeatableBlocks";
export type { RepeatableBlockProps, RepeatableBlocksProps } from "../../../../../shared/frontend/components/RepeatableBlocks";
